module.exports = __webpack_public_path__ + "media/images/menu/sagittarius-374fe08776150737d5a0eddb6d406388.jpg";